import React from 'react';

// Shared stat-tile used across Dashboard, Analytics and Invoice Tracking.
// The value stays in dark ink for legibility; the accent color lives on the
// icon (or a small dot when no icon is given) and, when `highlight` is set,
// on a soft tinted background for tiles that need extra attention.
const StatTile = ({ icon: Icon, label, value, color = '#0284c7', sub, highlight }) => (
  <div style={{
    background: highlight ? color + '0d' : '#fff',
    border: '1px solid ' + (highlight ? color + '40' : 'transparent'),
    borderRadius: 12,
    padding: 18,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
    flex: 1,
    minWidth: 170,
  }}>
    {Icon ? (
      <div style={{
        background: color + '20', borderRadius: 10, padding: 10,
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
      }}>
        <Icon size={20} color={color} />
      </div>
    ) : (
      <div style={{ width: 10, height: 10, borderRadius: '50%', background: color, marginTop: 7, flexShrink: 0 }} />
    )}
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', lineHeight: 1.15 }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: highlight ? color : '#94a3b8', marginTop: 2, fontWeight: highlight ? 600 : 400 }}>{sub}</div>}
    </div>
  </div>
);

export default StatTile;
